import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, catchError, throwError } from 'rxjs';
import { LoggerService } from '../logging/logger.service';

let correlationCounter = 0;

export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  const correlationId = `mfr-${Date.now()}-${++correlationCounter}`;
  const startTime = performance.now();

  const trackedReq = req.clone({
    setHeaders: { 'X-Correlation-ID': correlationId },
  });

  logger.info('HttpRequest', {
    method: req.method,
    // Log only path, never full URL with query params that may contain sensitive data
    path: new URL(req.urlWithParams, 'http://x').pathname,
    correlationId,
  });

  return next(trackedReq).pipe(
    tap((event) => {
      const duration = Math.round(performance.now() - startTime);
      logger.info('HttpResponse', { correlationId, durationMs: duration });
    }),
    catchError((error) => {
      const duration = Math.round(performance.now() - startTime);
      logger.error('HttpError', error, {
        correlationId,
        durationMs: duration,
        status: error?.status,
      });
      return throwError(() => error);
    })
  );
};
